export const getStringFromSearchParams = (searchParamsArray: [string, string[]][]) => {
  return searchParamsArray
    .map(([key, values]) => {
      return `${key}=${values.join(",")}`;
    })
    .join("&");
};
